import React from 'react';
// import MemberOnly from 'components/Promotions/InnerPage/MemberOnly';
// import ActivityInfo from 'components/Promotions/InnerPage/ActivityInfo';
// import WinningAnnouncement from 'components/Promotions/InnerPage/WinningAnnouncement';
// import Schemes from 'components/Promotions/InnerPage/Schemes';
// import ActivityNotes from 'components/Promotions/InnerPage/ActivityNotes';
// import PageNavControls from 'components/PageNavControls';

const PromotionsInnerPageC: React.FC = () => (
  <div className="promotions-inner-page promotions-inner-page-c">
    {
      /**

    <MemberOnly>
    <MemberOnly.Head />
    <MemberOnly.InnerPageCAds />
  </MemberOnly>

  <ActivityInfo />

  <WinningAnnouncement />

  <Schemes>
    <Schemes.InnerPageCSchemes />
  </Schemes>

  <ActivityNotes />

  <PageNavControls
    prevBtnLink="/"
    nextBtnLink="/"
    navBtnLink="/"
    navBtnText="回活動頁"
  />
      */
    }
  </div>
);

export default PromotionsInnerPageC;
